import React from 'react';

interface DemoWidgetProps {
  icon: string;
  title: string;
  product: string;
  script: string;
  children: React.ReactNode;
}

export default function DemoWidget({ icon, title, product, script, children }: DemoWidgetProps) {
  return (
    <div className="demo-widget">
      <div className="demo-widget-header">
        <div className="demo-widget-title">
          <span className="demo-widget-icon">{icon}</span>
          <div>
            <h3>{title}</h3>
            <span className="product-badge">{product}</span>
          </div>
        </div>
      </div>
      <div className="demo-widget-body">
        <p className="demo-script">{script}</p>
        <div style={{ marginTop: '1.25rem' }}>{children}</div>
      </div>
    </div>
  );
}
